import React from "react";
import AlInventoryStatus from "./LocationModule/AlInventoryStatus";

const InventoryStatus = () => {
  return (
    <div>
      <AlInventoryStatus />
    </div>
  );
};

export default InventoryStatus;
